import { render, staticRenderFns } from "./ConfigurationData.vue?vue&type=template&id=13a4989a&scoped=true"
import script from "./ConfigurationData.vue?vue&type=script&lang=js"
export * from "./ConfigurationData.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationData.vue?vue&type=style&index=0&id=13a4989a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4989a",
  null
  
)

export default component.exports